/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon, Heading, Stack, Text } from "components/index";

const HeaderSection = ({
  date,
  number,
}: {
  date: string | null;
  number: number;
}) => {
  const { t } = useTranslation();
  return (
    <Stack className="md:flex-row justify-between gap-x-5 items-start">
      <Stack className="hidden md:flex space-y-2.5">
        <Heading
          as="h2"
          className="-text--theme-colors-text-title-brand text-2xl"
        >
          {t("tripDetails.tripDetails", {
            number: String(number).padStart(2, "0"),
          })}
        </Heading>

        <Text className="max-w-md --theme-colors-text-body">
          {t("tripDetails.headerSectionMSG")}
        </Text>
      </Stack>

      {date && (
        <Stack className="space-y-2.5">
          <Heading as="h2" className="-text--theme-colors-text-title-brand">
            {t("tripDetails.tripDatesLabel")}
          </Heading>

          <div className="flex items-center gap-x-s5 -text--theme-colors-icon-primary">
            <FontAwesomeIcon name="fa-calendar-day" size="xl" />
            <Text className="-text--theme-colors-text-body font-normal ms-2">
              {date}
            </Text>
          </div>
        </Stack>
      )}
    </Stack>
  );
};

export default HeaderSection;
